import reactComponentLoader from 'scripts/react-component-loader'

import { Sidebar } from './components/Sidebar'

reactComponentLoader(Sidebar, '[data-user-sidebar]')
